import { isToday } from 'date-fns';

import { normalizeLocale } from '@/lib/utils/locale-shared';

export function formatMessageTimestamp({ date, locale }: { date: Date; locale: string }): string {
  const options: Intl.DateTimeFormatOptions = isToday(date)
    ? { hour: '2-digit', minute: '2-digit' }
    : { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };

  return new Intl.DateTimeFormat(normalizeLocale(locale), options).format(date);
}
